import http from '../helpers/http';
import WaitingListInterface from '../interfaces/WaitingListInterface';

const WaitingList = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    getNameSchool: async (school: string) => {
      const result = await http.get(`/schools/${school}/uri`, {
        headers,
      });
      return result.data;
    },
    getBySecret: async (secret: string) => {
      const result = await http.get(`/waiting-list/${secret}/public`);
      return result.data;
    },
    create: async (body: Partial<WaitingListInterface>) => {
      const result = await http.post(`/waiting-list/public`, body, { headers });
      return result.data;
    },
  };
};

export default WaitingList;
